module.exports = __webpack_public_path__ + "icon-sale.svg?95c46c29375bf0c914153ad95866de5e";